import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from './container/container.component';
import { PageIntroHeaderComponent } from './page-intro-header/page-intro-header.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { CustomPaginationComponent } from './custom-pagination/custom-pagination.component';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { CardHeaderComponent } from './card-header/card-header.component';
import { FieldHolderComponent } from './field-holder/field-holder.component';
import { FormFooterComponent } from './form-footer/form-footer.component';
import { AccountingReportMetadataComponent } from './accounting-report-metadata/accounting-report-metadata.component';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule, MatNavList } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { FormSubgroupDividerComponent } from '../components/form-components/form-subgroup-divider/form-subgroup-divider.component';
import { IconFileCSVComponent } from '../components/icons/file-csv/icon.component';
import { IconFilePDFComponent } from '../components/icons/file-pdf/icon.component';
import { FormGroupComponent } from '../components/form-components/form-group/form-group.component';
import { DefinitionItemComponent } from '../components/definition-list/definition-item/definition-item.component';
import { CardSubgroupDividerComponent } from '../components/readonly-card-components/card-subgroup-divider/card-subgroup-divider.component';
import { DefinitionListComponent } from '../components/definition-list/definition-list.component';
import { NoResultItemComponent } from '../components/no-result-item/no-result-item.component';
import { DocumentItemEvaluationComponent } from '../supervision/document-item-evaluation/document-item-evaluation.component';
import { IconFileComponent } from '../components/icons/icon-file/icon-file.component';
import { StatusLabelComponent } from '../components/status-label/status-label.component';
import { SubjectDocumentsComponent } from '../sidebar-widget/subject-documents/subject-documents.component';
import { DocumentListItemComponent } from '../components/document-list-item/document-list-item.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatBadgeModule } from '@angular/material/badge';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
   declarations: [
      ContainerComponent,
      PageIntroHeaderComponent,
      CustomPaginationComponent,
      CardHeaderComponent,
      FieldHolderComponent,
      FormFooterComponent,
      AccountingReportMetadataComponent,
      FormSubgroupDividerComponent,
      IconFileCSVComponent,
      IconFilePDFComponent,
      FormGroupComponent,
      DefinitionItemComponent,
      CardSubgroupDividerComponent,
      DefinitionListComponent,
      NoResultItemComponent,
      DocumentItemEvaluationComponent,
      IconFileComponent,
      StatusLabelComponent,
      SubjectDocumentsComponent,
      DocumentListItemComponent,
   ],
   imports: [
      CommonModule,
      TranslateModule,
      MatIconModule,
      MatOptionModule,
      MatFormFieldModule,
      MatSelectModule,
      MatTooltipModule,
      MatButtonModule,
      MatCardModule,
      MatMenuModule,
      MatDividerModule,
      MatListModule,
      MatProgressSpinnerModule,
      MatChipsModule,
      MatDatepickerModule,
      MatBadgeModule,
      MatAutocompleteModule,
      FormsModule,
      ReactiveFormsModule,
      MatInputModule,
      MatTabsModule,
   ],
   exports: [
      ContainerComponent,
      PageIntroHeaderComponent,
      CustomPaginationComponent,
      CardHeaderComponent,
      FieldHolderComponent,
      FormFooterComponent,
      AccountingReportMetadataComponent,
      FormSubgroupDividerComponent,
      IconFileCSVComponent,
      IconFilePDFComponent,
      FormGroupComponent,
      DefinitionItemComponent,
      CardSubgroupDividerComponent,
      DefinitionListComponent,
      NoResultItemComponent,
      DocumentItemEvaluationComponent,
      IconFileComponent,
      StatusLabelComponent,
      SubjectDocumentsComponent,
      TranslateModule,
      MatIconModule,
      MatOptionModule,
      MatFormFieldModule,
      MatSelectModule,
      MatTooltipModule,
      MatButtonModule,
      MatCardModule,
      MatMenuModule,
      MatDividerModule,
      MatListModule,
      MatProgressSpinnerModule,
      MatChipsModule,
      MatDatepickerModule,
      MatBadgeModule,
      MatAutocompleteModule,
      FormsModule,
      ReactiveFormsModule,
      DocumentListItemComponent,
      MatInputModule,
      MatTabsModule,
   ],
   entryComponents: [SubjectDocumentsComponent],
})
export class SharedModule {}
